import * as dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

const formatTimestamp = (date) => {
  if (date) {
    const diffSeconds = dayjs(new Date()).diff(new Date(date), 'seconds');
    const hum = dayjs.duration(-diffSeconds, 'seconds').humanize(true);
    return hum;
  }
  return '';
};

export default formatTimestamp;
